import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Users, Heart, ArrowRight, Megaphone } from "lucide-react";

const OPPORTUNITIES = [
  {
    icon: Users,
    title: "Become an Ambassador",
    desc: "Help spread the word about 614 Shop Local in your neighborhood. Share our mission and connect us with local businesses.",
    path: "/ambassador",
    cta: "Learn More"
  },
  {
    icon: Heart,
    title: "Become a Sponsor",
    desc: "Support our platform financially and gain visibility for your brand among Columbus's local shopping community.",
    path: "/sponsor",
    cta: "Sponsor Us"
  }
];

const WorkWithUsPage = () => {
  return (
    <div className="page-fade-in">
      {/* Hero */}
      <section className="bg-[#EEF8F2] text-[#1a1a1a] border-b border-[#42D78A]/20 py-20 md:py-24 px-6">
        <div className="max-w-4xl mx-auto text-center">
          <p className="text-[#42D78A] text-sm tracking-[0.2em] uppercase mb-4 font-medium" style={{ fontFamily: "'Montserrat', sans-serif" }}>Work With Us</p>
          <h1 className="text-4xl sm:text-5xl font-bold mb-4" style={{ fontFamily: "'Outfit', sans-serif" }}>
            Join the Movement
          </h1>
          <p className="text-gray-600 max-w-xl mx-auto" style={{ fontFamily: "'Montserrat', sans-serif" }}>
            There are many ways to get involved and support local businesses in Columbus.
          </p>
        </div>
      </section>

      {/* Opportunities */}
      <section className="py-20 px-6">
        <div className="max-w-5xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 stagger-in">
            {OPPORTUNITIES.map((item) => (
              <div
                key={item.title}
                className="bg-white border border-gray-100 rounded-2xl p-8 hover:shadow-lg transition-all hover:-translate-y-1 group"
                data-testid={`opportunity-${item.title.toLowerCase().replace(/\s+/g, '-')}`}
              >
                <div className="w-14 h-14 rounded-2xl bg-[#42D78A]/10 flex items-center justify-center mb-5 group-hover:bg-[#42D78A]/20 transition-colors">
                  <item.icon className="w-7 h-7 text-[#42D78A]" />
                </div>
                <h3 className="text-xl font-bold text-[#1a1a1a] mb-3" style={{ fontFamily: "'Outfit', sans-serif" }}>
                  {item.title}
                </h3>
                <p className="text-gray-600 text-sm leading-relaxed mb-4" style={{ fontFamily: "'Montserrat', sans-serif" }}>
                  {item.desc}
                </p>
                <Link to={item.path} className="inline-flex items-center text-sm font-bold text-[#42D78A] hover:underline" style={{ fontFamily: "'Outfit', sans-serif" }}>
                  {item.cta} <ArrowRight className="w-4 h-4 ml-1" />
                </Link>
              </div>
            ))}
          </div>

          <div className="mt-8 rounded-2xl border border-gray-100 bg-gray-50 p-6 md:p-8">
            <div className="grid grid-cols-1 md:grid-cols-[auto_1fr_auto] gap-5 items-center">
              <div className="w-14 h-14 rounded-2xl bg-[#42D78A]/10 flex items-center justify-center">
                <Megaphone className="w-7 h-7 text-[#42D78A]" />
              </div>
              <div>
                <h3 className="text-2xl font-bold text-[#1a1a1a] mb-2" style={{ fontFamily: "'Outfit', sans-serif" }}>
                  Join the Team
                </h3>
                <p className="text-gray-600 leading-relaxed" style={{ fontFamily: "'Montserrat', sans-serif" }}>
                  We are a volunteer-run team looking for help with social media marketing and outreach.
                </p>
              </div>
              <Link to="/join-the-team" className="inline-flex items-center text-sm font-bold text-[#42D78A] hover:underline" style={{ fontFamily: "'Outfit', sans-serif" }}>
                View Roles <ArrowRight className="w-4 h-4 ml-1" />
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-20 bg-gray-50 px-6">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="text-3xl font-bold text-[#1a1a1a] mb-4" style={{ fontFamily: "'Outfit', sans-serif" }}>
            Ready to Make a Difference?
          </h2>
          <p className="text-gray-600 mb-8" style={{ fontFamily: "'Montserrat', sans-serif" }}>
            Get in touch with us to learn more about how you can contribute to the 614 Shop Local community.
          </p>
          <Link to="/contact">
            <Button
              className="bg-[#42D78A] hover:bg-[#3bc27c] text-[#1a1a1a] rounded-full px-10 py-6 text-base font-bold transition-all hover:-translate-y-1"
              style={{ fontFamily: "'Outfit', sans-serif" }}
              data-testid="work-contact-btn"
            >
              Contact Us Today
            </Button>
          </Link>
        </div>
      </section>
    </div>
  );
};

export default WorkWithUsPage;
